export {default as RightText } from './RightText';